
import { mapGetters } from 'vuex'
import { header, contentHome } from '../customWhiteLabel'
export default {
  layout: 'e-commerce',
  data() {
    return {
      header,
      contentHome,
    }
  },
  computed: {
    ...mapGetters('unidade', ['isSdconsulta']),
  },
  mounted() {
    if (this.$nuxt.isOffline) {
      this.$toast.error('sem conexão de internet')
    }
    const x = 'ATENÇÃO!!!'
    const d =
      'Muito cuidado ao abrir o console, esta é uma ferramenta para desenvolvedores. Atenciosamente, Senha Digital.'
    console.log(`%c${x}`, 'font-size: 50px; color: red;')
    console.log(`%c${d}`, 'font-size: 20px; color: yellow;')
  },
}
